import { Component } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-date-input',
    standalone: false,
    templateUrl: './date-input.component.html',
    styleUrl: './date-input.component.scss',
})
export class DateInputComponent extends InputComponent {}
